import JSConfetti from "js-confetti";
import { useState } from "react";

interface AddConfettiConfig {
  confettiRadius?: number;
  confettiNumber?: number;
  confettiColors?: string[];

  // emojis could be used as confetti
  // confettiColors will be ignored if emojis array provided
  emojis?: string[];
  emojiSize?: number;

  // @deprecated: wrong plural forms were used
  emojies?: string[];
  confettiesNumber?: number;
}

function generateRandomArrayElement<T>(arr: T[]): T {
  return arr[generateRandomNumber(0, arr.length)];
}

function generateRandomNumber(
  min: number,
  max: number,
  fractionDigits = 0,
): number {
  const randomNumber = Math.random() * (max - min) + min;
  return Math.floor(randomNumber * 10 ** fractionDigits) / 10 ** fractionDigits;
}

let confettiInstance: JSConfetti;

export const useConfetti = () => {
  const [isConfettiRunning, setIsConfettiRunning] = useState(false);

  if (typeof document !== "undefined") {
    confettiInstance ||= new JSConfetti();
  }

  const triggerVibration = () => {
    if (navigator.vibrate) {
      // just for fun - trigger triple short vibrations
      // unfortunately not supported in iOS at this moment
      navigator.vibrate([100, 50, 100, 50, 100]);
    }
  };

  return {
    isConfettiRunning,
    addConfetti(configs: AddConfettiConfig[]) {
      setIsConfettiRunning(true);

      triggerVibration();

      configs = configs.map((config) => {
        return { ...config, confettiNumber: 80 };
      });

      return confettiInstance
        .addConfetti(generateRandomArrayElement(configs))
        .finally(() => {
          setIsConfettiRunning(false);
        });
    },
  };
};
